import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Collapse } from "@mui/material";
import classNames from "classnames";
// TODO: Design System 적용 확인 필요 2024.04.30
export function GrCollapse({ open, children, className, ...props }) {
    return (_jsx(Collapse, { className: classNames("GrCollapse", className), in: open, ...props, children: children }));
}
//# sourceMappingURL=GrCollapse.js.map